import React from 'react';
import SiteFooter from '../includes/SiteFooter';

class PagePreferencesSetNickname extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div id="site-main" className="page bow" role="main" tabIndex="-1">
          <div className="container" id="site-main-container">
            <div className="row">
              <div className="col-md1-24">
                <h4 className="subtitle">PagePreferencesShowHide</h4>
                <div className="pattern-body" />
              </div>
            </div>
          </div>
        </div>
        <SiteFooter />
      </div>
    );
  }
}

export default PagePreferencesSetNickname;
